<script>
  import _ from "lodash";
  import { matches, fallbackUrl } from "../config/matches.js";
  import { user } from "../stores";

  const getMatch = () =>
    _.find(
      matches,
      (m) =>
        m.match.region.indexOf($user.region) > -1 &&
        m.match.category.indexOf($user.category) > -1
    );

  const match = getMatch();

  const destination = _.get(match, "destination", fallbackUrl);

  let destinationUrl;
  let error = false;

  if (destination && typeof destination === "string") {
    destinationUrl = destination;
    window.location.href = destinationUrl + (window.location.search || "");
  } else if (destination && (typeof destination === "object")) {
    destinationUrl = destination[Math.floor(Math.random() * destination.length)];
    window.location.href = destinationUrl + (window.location.search || "");
  } else {
    error = true;
  }
</script>

<div class="section section-1" style="min-height: 100vh">
  <div class="container">
    {#if error === true}
      <div class="columns">
        <div class="column" style="text-align: center">
          <p style="text-align: center; color: #888; position: absolute; top:30px; left: 0; right: 0;">Siamo spiacenti, il tuo profilo non è finanziabile.</p>
        </div>
      </div>
   {/if}
  </div>
</div>
